import { render, staticRenderFns } from "./BlankTile.vue?vue&type=template&id=c5f3633e&"
import script from "./BlankTile.vue?vue&type=script&lang=js&"
export * from "./BlankTile.vue?vue&type=script&lang=js&"
import style0 from "./BlankTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports